import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ii",
  "use": "icon-ii-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ii\"><path d=\"M463.36 117.12c-13.44-13.44-20.16-29.76-20.16-48.96 0-18.56 6.72-34.56 20.16-48 13.76-13.44 30.08-20.16 49.28-20.16 18.56 0 34.56 6.72 48 20.16 13.44 13.44 20.16 29.44 20.16 48 0 19.2-6.72 35.52-20.16 48.96-13.44 13.44-29.44 20.16-48 20.16-19.2 0-35.52-6.72-49.28-20.16z m112.32 653.44V232.32h-116.16v538.24h116.16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol